import React from "react";
import Heading from "../../components/common/Typography/Heading";
import Paragraph from "../../components/common/Typography/Paragraph";
import Percentaging from "./Percentaging";
import {
  PUBLIC_ABOUT_COLUMN_GAP_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const RighText = ({ heading, text }) => {
  return (
    <>
      <div
        className={`flex flex-col lg:flex-row items-center tp-container-main mx-auto w-full ${PUBLIC_SECTION_GAP_CLASS} ${PUBLIC_ABOUT_COLUMN_GAP_CLASS}`}
      >
        <div className="order-2 lg:order-1 h-auto w-full lg:w-1/2 aspect-square shrink-0">
          <img
            className="object-cover w-full h-full rounded-xl"
            src={require("../../assets/img/TradesPosterSpeciality/businesses.jpg")}
            alt="trade-poster"
          />
        </div>
        <div
          className={`lg:my-auto order-1 lg:order-2 ${PUBLIC_HEADING_TO_CONTENT_CLASS} lg:mt-0`}
        >
          <div>
            <Heading variant={"h2"} className={"text-offblack"}>
              {heading}
            </Heading>
            <Paragraph variant={"MainParagraph"} className={PUBLIC_HEADING_TO_BODY_CLASS}>
              {text}
            </Paragraph>
          </div>
        </div>
      </div>

      
      {/* <div className="bg-gradient-to-t from-transparent from-0% via-white via-90% to-transparent to-100%">
      <div className="bg-gradient-to-t from-transparent from-0% via-white via-10% to-transparent to-100%"> */}
      <div
        className={`flex flex-col lg:flex-row justify-center items-center tp-container-main mx-auto w-full ${PUBLIC_SECTION_GAP_CLASS} ${PUBLIC_ABOUT_COLUMN_GAP_CLASS}`}
      >
        <div className="order-1 shrink-0 w-full h-auto lg:w-1/2 -mt-12">
          <div className="hidden lg:block">
            <Percentaging
              number={90}
              textColor={"text-softpurple"}
              text={"Profile visits"}
            />
          </div>
        </div>
        <div className="w-full order-1 lg:order-2 -mt-12">
        <div>
          <div>
            <Percentaging
              number={70}
              textColor={"text-freshgreen"}
              text={"Customer inquiries"}
            />
            <div className="lg:hidden mt-40">
              <Percentaging
                number={90}
                textColor={"text-softpurple"}
                text={"Profile visits"}
              />
            </div>
          </div>
          <div className="mt-60 lg:mt-80">
            <Percentaging
              number={80}
              textColor={"text-freshgreen"}
              text={"Faster responses"}
            />
          </div>
        </div>
        </div>
      </div>
      {/* </div>
      </div> */}
    </>
  );
};

export default RighText;
